import { get, post, del } from '../lib/apiClient';

/** GET /files — caller's files (query: limit, lastKey, ...) */
export const listFiles = (query) => get('/files', { query });

/**
 * POST /files/upload-url — request a presigned upload URL.
 * Payload: { fileName, fileSize, mimeType, ... } per the spec.
 */
export const createUploadUrl = (payload) => post('/files/upload-url', payload);

/** POST /files/complete-upload — { fileId } after the S3 PUT succeeds */
export const completeUpload = (payload) => post('/files/complete-upload', payload);

/** GET /files/{fileId}/download-url */
export const getDownloadUrl = (fileId) =>
  get(`/files/${encodeURIComponent(fileId)}/download-url`);

/** DELETE /files/{fileId} */
export const deleteFile = (fileId) => del(`/files/${encodeURIComponent(fileId)}`);

/**
 * Full browser-side upload flow: presign → PUT to S3 → complete.
 * Returns the completed file record. NOTE: uploads are scanned server-side
 * and are fail-closed — with no scanner deployed, downloads of new uploads
 * stay blocked (documented platform behaviour, not a frontend bug).
 */
export async function uploadFile(file) {
  const { uploadUrl, fileId } = await createUploadUrl({
    fileName: file.name,
    fileSize: file.size,
    mimeType: file.type || 'application/octet-stream'
  });
  const putResponse = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type || 'application/octet-stream' },
    body: file
  });
  if (!putResponse.ok) {
    throw new Error(`S3 upload failed (HTTP ${putResponse.status})`);
  }
  return completeUpload({ fileId });
}
